import type { ZoomConfig } from "../model/types/ArtworkPreviewTypes";

export const ZOOM_CONFIG: ZoomConfig = {
  step: 0.25,
  min: 1,
  max: 10,
  default: 1
};

export const DESKTOP_CONTAINER_SIZE = 540;
export const MOBILE_CONTAINER_PADDING = 32;
export const MOBILE_MAX_HEIGHT_RATIO = 0.6;
